/** @jsxImportSource @emotion/react */
import { Button } from '@mui/material'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import Input from 'components/Input'
import * as classes from './styles'

export type HeadValue = {
  text: string
  columnId: string
}

export type HeadCellProps = {
  value: HeadValue
  onChange: (value: HeadValue) => void
  onRemove: (value: HeadValue) => void
  isRemoveDisabled?: boolean
  isEditable?: boolean
}

export const HeadCell = ({
  value,
  onChange,
  onRemove,
  isRemoveDisabled = false,
  isEditable = false,
}: HeadCellProps) => (
  <div css={classes.cell} data-testid={`head-cell-${value.columnId}`}>
    <div css={classes.value}>
      {isEditable ? (
        <Input
          value={value.text}
          onChange={(text) => onChange({ ...value, text })}
          size="small"
          css={classes.input}
          required
          data-testid="head-cell-input"
        />
      ) : (
        <>{value.text}</>
      )}
    </div>
    {isEditable && (
      <Button
        variant="outlined"
        color="gray"
        size="small"
        css={classes.iconButton}
        onClick={() => onRemove(value)}
        disabled={isRemoveDisabled}
        data-testid="head-cell-remove-button"
      >
        <TrashIcon />
      </Button>
    )}
  </div>
)
